<template>
<div id="app">
  <v-app>
    <toast v-model="toastText"></toast>
    <toolbar :logo="logo" @drawer="toggleDrawer"></toolbar>
    <drawer :drawer.sync="drawer" :logo="logo" :menus="menus"></drawer>
    <v-content>
      <router-view @toast="toast" />
    </v-content>
  </v-app>
</div>
</template>

<script>
import Toolbar from '@/components/utils/Toolbar'
import Drawer from '@/components/utils/Drawer'
import menus from '@/helpers/menus'

export default {
  name: 'App',
  components: {
    'toolbar': Toolbar,
    'drawer': Drawer
  },
  data: () => ({
    drawer: null,
    menus: menus,
    logo: require('./assets/LogoIcons/logo_toolbar.svg'),
    toastText: null
  }),
  methods: {
    toggleDrawer() {
      this.drawer = !this.drawer
    },
    toast(val) {
      this.toastText = val;
    }
  },
  mounted() {
    this.$auth.onAuthStateChanged(user => {
      if (this.$root.userAuth) {
        let uid = this.$root.userAuth.uid;
        this.$db.ref(`userMacInfo/${uid}`).off();
        this.$db.ref(`userDevice/${uid}`).off();
        this.$db.ref(`userTargetName/${uid}`).off();
        this.$db.ref(`userCamera/${uid}`).off();
        this.$db.ref(`userFace/${uid}`).off();
        this.$db.ref(`userScene/${uid}`).off();
        this.$db.ref(`userMacro/${uid}`).off();
        this.$db.ref(`userMacroSchedule/${uid}`).off();
        this.$db.ref(`userContact/${uid}`).off();
        this.$db.ref(`userSchedule/${uid}`).off();
        this.$db.ref(`userKanban/${uid}`).off();
        this.$db.ref(`userStateTracker/${uid}`).off();
        this.$root.userMacInfo = null;
        this.$root.userDevice = null;
        this.$root.userTargetName = null;
        this.$root.userCamera = null;
        this.$root.userFace = null;
        this.$root.userScene = null;
        this.$root.userMacro = null;
        this.$root.userMacroSchedule = null;
        this.$root.userContact = null;
        this.$root.userSchedule = null;
        this.$root.userKanban = null;
        this.$root.userTracker = null;
        this.$root.userAuth = null;
      }
      if (user) {
        this.$root.userAuth = user;
        this.$db.ref(`userMacInfo/${user.uid}`).on('value', snapshot => {
          this.$root.userMacInfo = snapshot.val() || {};
        });
        this.$db.ref(`userDevice/${user.uid}`).on('value', snapshot => {
          this.$root.userDevice = snapshot.val() || {};
        });
        this.$db.ref(`userTargetName/${user.uid}`).on('value', snapshot => {
          this.$root.userTargetName = snapshot.val() || {};
        });
        this.$db.ref(`userCamera/${user.uid}`).on('value', snapshot => {
          this.$root.userCamera = snapshot.val() || {};
        });
        this.$db.ref(`userFace/${user.uid}`).on('value', snapshot => {
          this.$root.userFace = snapshot.val() || {};
        });
        this.$db.ref(`userScene/${user.uid}`).on('value', snapshot => {
          this.$root.userScene = snapshot.val() || {};
        });
        this.$db.ref(`userMacro/${user.uid}`).on('value', snapshot => {
          this.$root.userMacro = snapshot.val() || {};
        });
        this.$db.ref(`userMacroSchedule/${user.uid}`).on('value', snapshot => {
          this.$root.userMacroSchedule = snapshot.val() || {};
        });
        this.$db.ref(`userContact/${user.uid}`).on('value', snapshot => {
          this.$root.userContact = snapshot.val() || {};
        });
        this.$db.ref(`userSchedule/${user.uid}`).on('value', snapshot => {
          this.$root.userSchedule = snapshot.val() || {};
        });
        this.$db.ref(`userKanban/${user.uid}`).on('value', snapshot => {
          this.$root.userKanban = snapshot.val() || {};
        });
        this.$db.ref(`userStateTracker/${user.uid}`).on('value', snapshot => {
          this.$root.userTracker = snapshot.val() || {};
        });
      } else {
        this.$root.userAuth = {};
      }
    })
  }
}
</script>

<style>
@import 'vuetify/dist/vuetify.css';

.centerized {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 80%;
  transform: translate(-50%, -50%);
  text-align: center;
  line-height: 1.5em !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue